/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_Title_AccentInputs */

const tr_landing_cockpit_title_accent = /** @type {(inputs: Landing_Cockpit_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tek ekrana sığdırın`)
};

const en_landing_cockpit_title_accent = /** @type {(inputs: Landing_Cockpit_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`onto one screen`)
};

const de_landing_cockpit_title_accent = /** @type {(inputs: Landing_Cockpit_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auf einen Bildschirm`)
};

const ru_landing_cockpit_title_accent = /** @type {(inputs: Landing_Cockpit_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`на одном экране`)
};

/**
* | output |
* | --- |
* | "onto one screen" |
*
* @param {Landing_Cockpit_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_title_accent = /** @type {((inputs?: Landing_Cockpit_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_title_accent(inputs)
	if (locale === "de") return de_landing_cockpit_title_accent(inputs)
	if (locale === "ru") return ru_landing_cockpit_title_accent(inputs)
	return tr_landing_cockpit_title_accent(inputs)
});